import Home from './containers/Home';
import AboutUs from './containers/AboutUs';
import Remittance from './containers/Remittance';
import ChooseTheRemittance from './containers/ChooseTheRemittance';
import OtherServices from './containers/OtherServices';
import CustomerTestimonials from './containers/CustomerTestimonials';
import Footer from './containers/Footer';
import ContactUs from './containers/ContactUs/ContactUs';
import StickyNavbar from './containers/Header/StickyNavBar';
import { Box, Text, Image } from '@mantine/core';
import { ForeColorWhite } from './lib/constants';


function Mnlexpress(){
    return(
         <div className="Mnlexpress" style={{ position: 'relative' }}>
            <StickyNavbar/>
            <Home />
            <AboutUs />
            <ChooseTheRemittance />
            <OtherServices />
            <ContactUs/>
            {/* <Footer /> */}
        </div>
    );
}

export default Mnlexpress;